import React, { useEffect, useState } from "react";
import {
  fetchBuOptions,
  getNamesofAgreement,
  getTitlesOfAgreement,
} from "../apis/userApis";
import {
  ActionIcon,
  Button,
  Checkbox,
  Modal,
  Pagination,
  Select,
  Table,
  Text,
  TextInput,
} from "@mantine/core";
import { csvDownload, excelDownload, formatDatetoISO } from "./utilities";
import { IconEye, IconPlus, IconTrash } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { INDIA_STATES_UNIONS } from "./constants";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteAgreement,
  getLocalAgreements,
  getLocalAgreementsCSV,
} from "../apis/obligationApi";
import { showNotification } from "@mantine/notifications";
import UniversalTable from "../componenets/Common/UniversalTable";
import TablePagination from "../componenets/Common/TablePagination";

const DocsLocker = ({ showSelect = false, setAgreementId, setShowModal }) => {
  const navigate = useNavigate();
  const [configs, setConfigs] = useState({
    loading: true,
    agreements: null,
    count: 0,
  });
  const [page, setPage] = useState(1);

  const [buData, setBuData] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
    const [pageSize, setPageSize] = useState(10); // Add this line
  useEffect(() => {
    const getBuData = async () => {
      const response = await fetchBuOptions();
      setBuData(response.buData);
    };
    getBuData();
  }, []);
  const [applyFilters, setApplyFilters] = useState(false);
  const [filters, setFilters] = useState({
    location: null,
    titleOfAgreement: null,
    businessUnit: null,
    typeOfAgreement: null,
    OR: [
      { secondParty: { path: "$.name", string_contains: "" } },
      {
        secondParty: {
          path: "$.indi_name",
          string_contains: "",
        },
      },
    ],
    joOrder: null
  });
  console.log("filters: ", filters);
  const [categoryOptions, setCategoryOptions] = useState([
    "NDA",
    "Service Agreement",
  ]);
  const [nameOptions, setNameOptions] = useState([
    "truecounsel NDA",
    "tc services",
  ]);

  useEffect(() => {
    const getTitles = async () => {
      const response = await getTitlesOfAgreement();
      if (response.success) {
        setNameOptions(response.titlesOfAgreement);
      }
    };
    const getNames = async () => {
      const response = await getNamesofAgreement();
      if (response.success) {
        setCategoryOptions(response.namesOfAgreement);
      }
    };
    getTitles();
    getNames();
  }, []);

  useEffect(() => {
    const getAgreements = async () => {
      let filtersForData = Object.fromEntries(
        Object.entries(filters).filter(([key, value]) => value !== null)
      );

      console.log("filtersForData: ", filtersForData);

      // Check if "OR" exists and has the expected structure before accessing its values
      if (
        filtersForData.OR &&
        filtersForData.OR[0] &&
        filtersForData.OR[0].secondParty &&
        filtersForData.OR[0].secondParty.string_contains === ""
      ) {
        filtersForData = Object.fromEntries(
          Object.entries(filtersForData).filter(([key]) => key !== "OR")
        );
      }

      console.log("Updated filtersForData: ", filtersForData);
      console.log("filtersForData2: ", filtersForData);
      const response = await getLocalAgreements({
        page,
        filters: filtersForData,
      });
      if (response.success) {
        setConfigs({
          loading: false,
          agreements: response.agreements,
          count: response.count,
        });
        console.log(configs);
      } else {
        setConfigs({
          loading: false,
          agreements: null,
          count: 0,
        });
      }
    };
    getAgreements();
  }, [page, applyFilters]);
  const onViewClick = (id) => {
    window.open(`/viewagreement/${id}`, '_blank');
  };
  const exportCSV = async () => {
    let filtersForData = Object.fromEntries(
      Object.entries(filters).filter(([key, value]) => value !== null)
    );

    console.log("filtersForData: ", filtersForData);

    // Check if "OR" exists and has the expected structure before accessing its values
    if (
      filtersForData.OR &&
      filtersForData.OR[0] &&
      filtersForData.OR[0].secondParty &&
      filtersForData.OR[0].secondParty.string_contains === ""
    ) {
      filtersForData = Object.fromEntries(
        Object.entries(filtersForData).filter(([key]) => key !== "OR")
      );
    }
    const response = await getLocalAgreementsCSV({
      page: 1,
      filters: filtersForData,
    });
    console.log("export csv response: ", response);
    if (response.success) {
      const columnHeaders = Object.keys(response?.agreements[0]);
      excelDownload({
        data: response.agreements,
        headers: columnHeaders,
        name: "agreements",
      });
    }
  };

  function handleCloseDeleteModal(){
    setDeleteId(0);
    setDeleteModal(false);
  }
  const handleDelete =async()=>{
    const resp = await deleteAgreement({agreementId: deleteId});
    if (resp.success) {
      showNotification({
        title: "delete agreement",
        message: "agreement deleted ",
        color:"green"
      });
      setApplyFilters(!applyFilters);
      setDeleteModal(false);
      setDeleteId(0);
    }
  }

  // const agreementHeaders = [
  //   {
  //     label: "CIN",
  //     render: (row) => <Text size="sm" weight={600} color="#43A3B3">{row.agreementId}</Text>,
  //   },
  //   { 
  //     label: "CONTRACT TYPE", 
  //     render: (row) => row.typeOfAgreement || "--" 
  //   },
  //   { 
  //     label: "TITLE", 
  //     render: (row) => row.titleOfAgreement || "--" 
  //   },
  //   {
  //     label: "SECOND PARTY",
  //     render: (row) => (
  //       <div>
  //         <Text size="sm" weight={500}>{row.brandName}</Text>
  //         <Text size="xs" color="dimmed">
  //           {`(${row.secondParty?.name || row.secondParty?.indi_name || "--"})`}
  //         </Text>
  //       </div>
  //     ),
  //   },
  //   { 
  //     label: "BUSINESS UNIT", 
  //     key: "businessUnit" 
  //   },
  //   { 
  //     label: "JOB ORDER", 
  //     render: (row) => row.joOrder || "--" 
  //   },
  //   { 
  //     label: "END DATE", 
  //     render: (row) => formatDatetoISO(row.endDate) 
  //   },
  //   {
  //     label: "OBLIGATIONS",
  //     align: "center",
  //     render: (row) => (
  //       <div className="flex justify-center">
  //         {showSelect ? (
  //           <Checkbox
  //             onChange={() => {
  //               setAgreementId(row.agreementId);
  //               setShowModal(false);
  //             }}style={{ minWidth: "90px" }}
  //           />
  //         ) : (
  //           <ActionIcon onClick={() => onViewClick(row.agreementId)} variant="subtle">
  //             <IconEye size={24} />
  //           </ActionIcon>
  //         )}
  //       </div>
  //     ),
  //   },
  //   // Conditionally add the Delete column if not in selection mode
  //   ...(!showSelect ? [{
  //     label: "",
  //     align: "center",
  //     render: (row) => (
  //       <ActionIcon
  //         onClick={() => {
  //           setDeleteId(row.agreementId);
  //           setDeleteModal(true);
  //         }}
  //       >
  //         <IconTrash color="#1b6f8d" size={24} />
  //       </ActionIcon>
  //     ),
  //   }] : [])
  // ];
  const agreementHeaders = [
  {
    label: "CIN ",
    render: (row) => <Text size="xs" weight={600} miw={30} color="#43A3B3">{row.agreementId}</Text>,
  },
  { 
    label: "CONTRACT TYPE", 
    render: (row) => <Text size="xs">{row.typeOfAgreement || "--"}</Text>
  },
  { 
    label: "TITLE", 
    render: (row) => <Text size="xs">{row.titleOfAgreement || "--"}</Text>
  },
  {
    label: "SECOND PARTY",
    render: (row) => (
      <div>
        <Text size="xs" weight={500}>{row.brandName}</Text>
        <Text size="xs" color="dimmed">
          {`(${row.secondParty?.name || row.secondParty?.indi_name || "--"})`}
        </Text>
      </div>
    ),
  },
  { 
    label: "BU", 
    key: "businessUnit" 
  },
  { 
    label: "JOB ORDER", 
    render: (row) => <Text size="xs" miw={70}>{row.joOrder || "--"}</Text>
  },
  { 
    label: "END DATE", 
    render: (row) => <Text size="xs">{formatDatetoISO(row.endDate)}</Text>
  },
  {
    label: "OBLIGATIONS",
    align: "center",
    render: (row) => (
      <div className="flex justify-center">
        {showSelect ? (
          <Checkbox
            onChange={() => {
              setAgreementId(row.agreementId);
              setShowModal(false);
            }}
            style={{ minWidth: "90px" }}
          />
        ) : (
          <ActionIcon onClick={() => onViewClick(row.agreementId)} variant="subtle">
            <IconEye size={24} />
          </ActionIcon>
        )}
      </div>
    ),
  },
  ...(!showSelect ? [{
    label: "",
    align: "center",
    render: (row) => (
      <ActionIcon
        onClick={() => {
          setDeleteId(row.agreementId);
          setDeleteModal(true);
        }}
      >
        <IconTrash color="#1b6f8d" size={24} />
      </ActionIcon>
    ),
  }] : [])
];
  return (
    <>
      {/* <Text className="flex justify-start font-semibold text-xl m-4">
        Repository
      </Text> */}
      <div className="grid grid-cols-6 gap-4 m-4">
        <Select
          searchable
          label="contract type"
          placeholder="contract type"
          value={filters.typeOfAgreement}
          data={categoryOptions}
          onChange={(val) => setFilters({ ...filters, typeOfAgreement: val })}
        />
        <Select
          searchable
          placeholder="contract title"
          label="title"
          value={filters.titleOfAgreement}
          data={nameOptions}
          onChange={(val) => setFilters({ ...filters, titleOfAgreement: val })}
        />

        {buData !== null && (
          <Select
            label="business unit"
            placeholder="select business unit"
            data={buData}
            onChange={(val) => setFilters({ ...filters, businessUnit: val })}
            value={filters.businessUnit}
          />
        )}
        <TextInput
          label="second party"
          type="text"
          placeholder="type to search..."
          value={filters.OR[0].secondParty.string_contains}
          onChange={(e) => {
            // const value = e.target.value;

            setFilters((prevFilters) => ({
              ...prevFilters, // Preserve the existing filters
              OR: [
                {
                  secondParty: {
                    path: "$.name",
                    string_contains: e.target.value,
                  },
                },
                {
                  secondParty: {
                    path: "$.indi_name",
                    string_contains: e.target.value,
                  },
                },
              ],
            }));
          }}
        />
        <TextInput
          label="job order"
          placeholder="enter job order"
          value={filters.joOrder?.contains ? filters.joOrder?.contains : ""}
          onChange={(e) =>
            setFilters({
              ...filters,
              joOrder: { ...filters.joOrder, contains: e.target.value },
            })
          }
        />

        {/* <Select
          placeholder="location"
          label="location"
          value={filters.location}
          data={INDIA_STATES_UNIONS}
          onChange={(val) => setFilters({ ...filters, location: val })}
        /> */}
      </div>
      <div className="m-4">
        <Button
          onClick={() => setApplyFilters(!applyFilters)}
          className="mr-4"
          variant="outline"
        >
          Search
        </Button>
        <Button
          onClick={() => {
            window.location.reload();
          }}
        >
          Clear
        </Button>
      </div>
      {!configs.loading && configs.agreements && (
        <>
          <div className="flex justify-end m-4">
            <Button
              style={{ backgroundColor: "#1b6f8d" }}
              onClick={() => exportCSV()}
            >
              Export
            </Button>
          </div>
         
          <UniversalTable
            headers={agreementHeaders}
            data={configs.agreements}
            loading={configs.loading}
          />

          <TablePagination
            totalCount={configs.count}
            page={page}
            pageSize={pageSize} // Ensure 'pageSize' state exists in your component
            dataLength={configs.agreements?.length || 0}
            onPageChange={(val) => setPage(val)}
            onPageSizeChange={(val) => {
              setPageSize(val);
              setPage(1); // Standard practice: reset to page 1 on limit change
            }}
          />
          <Modal
            opened={deleteModal}
            onClose={handleCloseDeleteModal}
            title="delete agreement"
          >
            <div className="p-4">
              <Text>are you sure you want to delete this agreement</Text>
              <div className="mt-4 flex justify-between">
                <Button onClick={handleCloseDeleteModal}>Cancel</Button>
                <Button color="#1b6f8d" onClick={handleDelete}>
                  Delete
                </Button>
              </div>
            </div>
          </Modal>
        </>
      )}
    </>
  );
};

export default DocsLocker;
